<template>
  <div class="mg-fast-add" @keydown.left.prevent.stop="handleKeyLeft" @keydown.right.prevent.stop="handleKeyRight"
    @keydown.f10.prevent.stop="handleKeyF10" @keydown.f8.prevent.stop="handleKeyF8">
    <mg-space>
      <mg-autocomplete ref="mgAutocomplete" v-model="form.skuName" :placeholder="placeholder" :trigger-on-focus="false"
        select-when-unmatched :select-when-matched-one="selectWhenMatchedOne" :highlight-first-item="true"
        :hide-suggestion="true" :columns="columns" :search-modes="searchModeParams" :table-business-type="cacheKey"
        @select="handleSelect" @suggestions-dialog-close="onSuggestionsDialogClose"
        @suggestions-dialog-open="onSuggestionsDialogOpen"
        :use-shortcut-center="useScanCenter"
        :style="{ width: `${$pxToRem(searchBarWidth)}` }" :debounce="50" :can-edit="canEdit" v-bind="$attrs"
        v-on="$listeners">
        <template #suffix>[F8]</template>
      </mg-autocomplete>

      <el-input ref="qty" data-class="mousetrap" v-model.number="form[defaultQty]" @keydown.up.native.prevent="addQty"
        @keydown.down.native.prevent="minusQty" @keydown.enter.native="handleKeyEnter" @input="handleQtyInput"
        v-if="ifDefaultQtyField" style="width: 120px">
        <template slot="prepend">{{ $MGUI.i18n.t('数量') }}</template>
      </el-input>

      <el-button class="search-button" type="primary" icon="iconfont mg-icon_sousuo_wubiankuang"
        @click="clickTriggerSearch">
        {{ $MGUI.i18n.t('查询[Enter]') }}
      </el-button>

      <el-checkbox v-if="isShowAccumulate" v-model="ifAccumulate">{{ $MGUI.i18n.t('累加重复商品') }}</el-checkbox>

      <mg-space v-if="showSearchMode" :space="0">
        <span style="line-height: 19px">{{ $MGUI.i18n.t('搜索模式[F10]：') }}</span>
        <mg-select style="width: 110px" :data="searchModeOptions" v-model="searchModeValue" size="mini" />
      </mg-space>

      <!-- 默认插槽 -->
      <slot />

      <!-- 业务特殊配置复选框插槽 -->
      <slot name="extra" />
      <el-checkbox v-if="isShowAutoSelect" v-model="isAutoSelect">{{ $MGUI.i18n.t('自动添加到明细') }}</el-checkbox>
      <!-- <el-popover placement="bottom" trigger="click" v-model="popover">
        <el-checkbox v-if="isShowAccumulate" v-model="ifAccumulate">{{ $MGUI.i18n.t('累加重复商品') }}</el-checkbox>
        <el-checkbox v-model="isEnableDialog">{{ $MGUI.i18n.t('弹窗展示商品') }}</el-checkbox>
        <el-checkbox v-if="isShowOnlySingle" v-model="onlySingle">{{ $MGUI.i18n.t('仅添加单个商品') }}</el-checkbox>
        <slot name="inpop" />

        <i
          slot="reference"
          class="popover-arrow"
          :class="popover ? 'el-icon-d-arrow-right' : 'el-icon-d-arrow-left'"
        ></i>
      </el-popover> -->
    </mg-space>
  </div>
</template>

<script>
import { keepAliveRoutes } from '@/config'
import JSScanner from '@/utils/JSScanner'
import useShortcuts from '@/mixins/useShortcuts'
import { WebFunnyEventCode } from '@/constants'
import { sendWebFunnyEvent } from '@/utils'
import i18n from '@/locale'

export default {
  name: 'MgFastAdd',
  mixins: [useShortcuts],
  props: {
    searchBarWidth: {
      type: Number,
      default: 355,
    },
    defaultColumns: {
      type: Array,
      default: () => [
        {
          label: i18n.t('SKU编码'),
          prop: 'skuCode',
          minWidth: '70px',
        },
        {
          label: i18n.t('SKU名称'),
          prop: 'skuName',
          minWidth: '300px',
        },
        {
          label: i18n.t('货号'),
          prop: 'articleNo',
          minWidth: '70px',
        },
        {
          label: i18n.t('料号'),
          prop: 'partNo',
          minWidth: '100px',
        },
      ],
    },
    appendColumns: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: i18n.t('SKU编码/名称/货号/助记码/条码'),
    },
    // 默认展示的数量字段 none 不展示
    defaultQty: {
      type: String,
      default: 'none',
    },
    // 当匹配到一条数据时，是否自动选择
    selectWhenMatchedOne: {
      type: Boolean,
      default: true,
    },
    // sku 选择前的回调
    beforeSkuSelect: Function,
    // 缓存配置的key
    cacheKey: String,
    // 是否判断扫码枪录入
    checkScanGun: {
      type: Boolean,
      default: false,
    },
    // 是否展示搜索模式
    showSearchMode: {
      type: Boolean,
      default: false,
    },
    // 是否展示重复累加
    isShowAccumulate: {
      type: Boolean,
      default: false,
    },
    // 重复累加默认值
    defaultAccumulate: {
      type: Boolean,
      default: true,
    },
    // 搜索模式默认值
    defaultSearchModeValue: {
      type: String,
      default: 'auto',
    },
    // 搜索模式默认选项
    defaultSearchModeOptions: {
      type: Array,
      default: () => [
        { label: i18n.t('自动判断'), value: 'auto' },
        { label: i18n.t('只搜条码'), value: 'onlyBarcode', params: { uesBarcode: true } },
      ],
    },
    // 额外的搜索模式选项
    appendSearchModeOptions: {
      type: Array,
      default: () => [],
    },
    // 是否展示 “仅添加单个商品”
    isShowOnlySingle: {
      type: Boolean,
      default: false,
    },
    // 仅添加单个商品 默认值
    defaultOnlySingle: {
      type: Boolean,
      default: false,
    },
    // 弹窗展示默认值
    defaultEnableDialog: {
      type: Boolean,
      default: false,
    },
    // 是否展示 自动添加默认值
    isShowAutoSelect: {
      type: Boolean,
      default: false,
    },
    // 自动添加默认值
    defaultAutoSelect: {
      type: Boolean,
      default: true,
    },
    // 是否可以编辑（用于控制是否允许选择商品）
    canEdit: {
      type: Boolean,
      default: true,
    },
    /** 为 true 时卸掉全局扫码监听并 blur 搜索框（如无码商品弹窗打开） */
    pauseScanner: {
      type: Boolean,
      default: false,
    },
    /**
     * true：走快捷键中心 ScannerCore（仅 newCashier 等场景传 true）
     * false：本地 JSScanner（全站默认，保护其它模块）
     */
    useScanCenter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 展示列数据
    columns() {
      return this.defaultColumns.concat(this.appendColumns)
    },

    // 搜索模式数据初始化
    searchModeOptions() {
      return this.defaultSearchModeOptions
        .concat(this.appendSearchModeOptions)
        .map((item) => ({ ...item, label: i18n.t(item.label) }))
    },

    ifDefaultQtyField() {
      return this.defaultQty !== 'none'
    },

    // 累加商品的存储 key
    accumulateKey() {
      return `${this.cacheKey}_ACCUMULATE`
    },

    // 搜索模式对应的传参
    searchModeParams() {
      // 若为自动搜索且是扫码枪录入
      // if (this.searchModeValue === 'auto' && this.ifScanGun) return { uesBarcode: true }
      // return this.searchModeOptions.find((i) => i.value === this.searchModeValue).params ?? {}

      // 若为自动搜索且是扫码枪录入
      if (this.searchModeValue === 'auto' && this.ifScanGun) return { uesBarcode: true }

      const option = this.searchModeOptions.find((i) => i.value === this.searchModeValue)
      return option?.params ?? {}
    },
  },
  data() {
    return {
      popover: false,
      form: {
        skuCode: null,
        skuName: null,
      },
      // 搜索模式
      searchModeValue: this.defaultSearchModeValue,
      // 累加重复商品
      ifAccumulate: this.defaultAccumulate,
      // 记录对于扫码枪的判断
      ifScanGun: false,
      // 仅添加单个商品
      onlySingle: this.defaultOnlySingle,
      // 是否启用弹窗展示商品
      isEnableDialog: this.defaultEnableDialog,
      isAutoSelect: this.defaultAutoSelect,
    }
  },
  watch: {
    ifAccumulate(bool) {
      if (!this.cacheKey) return
      const { setStorage } = this.$MGUI?.storage
      if (typeof setStorage === 'function') {
        setStorage(this.accumulateKey, bool)
      }
    },
    searchModeValue: {
      immediate: true,
      handler(val) {
        // 搜索模式附带请求参数
        const searchModeParams = this.searchModeOptions.find((i) => i.value === val).params ?? {}
        this.$emit('on-search-mode-change', { searchMode: val, searchModeParams })
      },
    },
    pauseScanner(paused) {
      if (paused) {
        this.handOffScanner()
        this.$nextTick(() => this.blurSearchInput())
      } else {
        this.$nextTick(() => this.handOnScanner())
      }
    },
  },

  activated() {
    // 重新获取输入框（因为 keep-alive 可能导致 DOM 变化）
    this.inputComponents = Array.from(this.$el.querySelectorAll('input.el-input__inner')).filter(
      (item) => !item.classList.contains('suggestion-dialog__input')
    )

    if (this.useScanCenter) {
      if (this.pauseScanner) {
        this.$shortcuts?.setOnScan?.(this._shortcutScopeId, null)
        this.$nextTick(() => this.blurSearchInput())
      }
      return
    }

    // 创建输入判断
    if (!this.JSScanner) {
      this.JSScanner = new JSScanner()
    }

    this.JSScanner.off()

    this.JSScanner.on((code, ifScanGun) => {
      if (this.pauseScanner) return
      this.ifScanGun = ifScanGun
      if (ifScanGun) {
        this.disableIMEForScanning()

        if (code.toLowerCase().includes('process')) {
          this.$message.warning('输入法与扫码枪不兼容, 建议使用搜狗输入法。')
        }

        this.$refs?.mgAutocomplete?.handleKeyEnter({
          preventDefault: () => {},
          target: { value: code },
          ifScanGun,
        })

        this.form.skuName = code
      }
    })

    this.$once('hook:deactivated', () => {
      this.JSScanner.off()
    })

    if (this.pauseScanner) {
      this.handOffScanner()
      this.$nextTick(() => this.blurSearchInput())
    }
  },

  created() {
    if (this.ifDefaultQtyField) {
      this.$set(this.form, this.defaultQty, 1)
    }
    if (this.cacheKey) {
      const { getStorage } = this.$MGUI?.storage
      if (typeof getStorage === 'function') {
        this.ifAccumulate = getStorage(this.accumulateKey) ?? this.defaultAccumulate
        // this.isAutoSelect = getStorage(this.autoSelectKey) ?? this.defaultAutoSelect
        this.isAutoSelect = this.defaultAutoSelect
        this.isEnableDialog = getStorage(this.dialogKey) ?? this.defaultEnableDialog
        this.onlySingle = getStorage(this.onlySingleKey) ?? this.defaultOnlySingle
      }
    }
  },

  mounted() {
    // 过滤掉弹窗内的 input
    this.inputComponents = Array.from(this.$el.querySelectorAll('input.el-input__inner')).filter(
      (item) => !item.classList.contains('suggestion-dialog__input')
    )

    if (this.useScanCenter) {
      this.bindShortcuts(
        {},
        {
          layer: 'widget',
          onScan: this.pauseScanner ? null : this.handleScanInput,
        }
      )
      if (this.pauseScanner) {
        this.$nextTick(() => this.blurSearchInput())
      }
      return
    }

    // 创建输入判断
    if (!this.JSScanner) {
      this.JSScanner = new JSScanner()
    }

    this.JSScanner.off()

    this.JSScanner.on((code, ifScanGun) => {
      if (this.pauseScanner) return
      this.ifScanGun = ifScanGun
      if (ifScanGun) {
        this.disableIMEForScanning()

        if (code.toLowerCase().includes('process')) {
          this.$message.warning('输入法与扫码枪不兼容, 建议使用搜狗输入法。')
        }

        this.$refs?.mgAutocomplete?.handleKeyEnter({
          preventDefault: () => {},
          target: { value: code },
          ifScanGun,
        })

        this.form.skuName = code
      }
    })

    // 页面组件是否被缓存
    if (keepAliveRoutes.includes(this.$route.name)) {
      this.$once('hook:deactivated', () => {
        this.JSScanner.off()
      })
    } else {
      this.$once('hook:beforeDestroy', () => {
        this.JSScanner.off()
      })
    }

    if (this.pauseScanner) {
      this.handOffScanner()
      this.$nextTick(() => this.blurSearchInput())
    }
  },
  methods: {
    /**
     * 禁用输入法以解决扫码枪输入问题
     * 使用多种方法组合，提高拦截成功率
     */
    disableIMEForScanning() {
      // 获取当前活跃的输入框（可能是 input 元素或其父元素）
      let activeInput = document.activeElement

      // 如果是 Element UI 的 input，需要找到实际的 input 元素
      if (activeInput && activeInput.classList && activeInput.classList.contains('el-input__inner')) {
        // 已经是 input 元素
      } else if (activeInput && activeInput.querySelector) {
        // 尝试在父元素中查找 input
        const input = activeInput.querySelector('input.el-input__inner')
        if (input) {
          activeInput = input
        }
      }

      if (activeInput && activeInput.tagName === 'INPUT') {
        console.log('TIPS caisher disableIMEForScanning activeInput is INPUT')

        // 方法1: 使用 CSS imeMode（兼容性有限）
        activeInput.style.imeMode = 'disabled'

        // 方法2: 使用 inputmode 属性（现代浏览器支持更好）
        if (activeInput.hasAttribute('inputmode')) {
          activeInput.setAttribute('inputmode', 'none')
        } else {
          activeInput.setAttribute('inputmode', 'none')
        }

        // 方法3: 监听并阻止输入法组合事件
        const preventComposition = (e) => {
          // 如果是扫码枪输入（快速连续输入），阻止输入法处理
          if (this.ifScanGun) {
            e.preventDefault()
            e.stopPropagation()
            return false
          }
        }

        // 添加事件监听器
        activeInput.addEventListener('compositionstart', preventComposition, { capture: true, once: true })
        activeInput.addEventListener('compositionupdate', preventComposition, { capture: true, once: true })

        // 设置一个定时器，在输入完成后恢复输入法
        const restoreTimer = setTimeout(() => {
          activeInput.style.imeMode = 'auto'
          if (activeInput.hasAttribute('inputmode')) {
            activeInput.removeAttribute('inputmode')
          }
          // 清理事件监听器
          activeInput.removeEventListener('compositionstart', preventComposition, { capture: true })
          activeInput.removeEventListener('compositionupdate', preventComposition, { capture: true })
        }, 2000) // 延长到2秒，确保扫码完成

        // 如果输入框失去焦点，立即恢复
        const onBlur = () => {
          clearTimeout(restoreTimer)
          activeInput.style.imeMode = 'auto'
          if (activeInput.hasAttribute('inputmode')) {
            activeInput.removeAttribute('inputmode')
          }
          activeInput.removeEventListener('blur', onBlur)
          activeInput.removeEventListener('compositionstart', preventComposition, { capture: true })
          activeInput.removeEventListener('compositionupdate', preventComposition, { capture: true })
        }
        activeInput.addEventListener('blur', onBlur, { once: true })
      }
    },
    /**
     * F10 切换搜索模式
     */
    handleKeyF10() {
      if (!this.showSearchMode) return
      let index = this.searchModeOptions.findIndex((item) => item.value === this.searchModeValue)
      if (++index >= this.searchModeOptions.length) index = 0
      this.searchModeValue = this.searchModeOptions[index].value
    },

    handleKeyF8() {
      this.clickTriggerSearch()
    },

    // 下一个焦点
    handleKeyRight() {
      const index = this.getCurrentActiveElementIndex()
      this.setFocusIndex(index + 1)
    },

    // 上一个焦点
    handleKeyLeft() {
      const index = this.getCurrentActiveElementIndex()
      this.setFocusIndex(index - 1)
    },

    getCurrentActiveElementIndex() {
      return this.inputComponents.findIndex((el) => {
        return el === document.activeElement
      })
    },

    // 重置 active 元素
    resetCurrentActiveElement() {
      if (this.getCurrentActiveElementIndex() === -1) {
        this.setFocusIndex(0) //2025/11/12 7:48 先注释掉
      }
    },

    handleKeyEnter(e) {
      if (this.form.skuCode) {
        e && e.preventDefault()
        this.handleConfirm()
      }
    },

    /**
     * 手动触发查询
     */
    clickTriggerSearch() {
      sendWebFunnyEvent(WebFunnyEventCode.PAGE, {
        actionType: `快速添加-查询`,
      })
      if (this.form.skuName?.trim()) {
        this.$refs.mgAutocomplete.handleKeyEnter({
          preventDefault: () => { },
          target: { value: this.form.skuName },
        })
      }
    },

    handleSelect(sku) {
      const next = () => {
        this.form = { ...this.form, ...sku }
        if (this.isAutoSelect || !this.ifDefaultQtyField) {
          this.handleConfirm()
          return
        }
        if (!this.isAutoSelect) this.resetCurrentActiveElement()
        this.handleKeyRight()
      }
      if (typeof this.beforeSkuSelect === 'function') {
        this.beforeSkuSelect({ sku, ifAccumulate: this.ifAccumulate, isAutoSelect: this.isAutoSelect }, next)
        if (!this.isAutoSelect) this.resetCurrentActiveElement()
        return
      }
      next()
    },

    // handleSelect(sku) {
    //   const next = () => {
    //     this.form = { ...this.form, ...sku }
    //     this.handleConfirm()
    //   }
    //   if (typeof this.beforeSkuSelect === 'function') {
    //     this.beforeSkuSelect({ sku, ifAccumulate: this.ifAccumulate }, next)
    //     return
    //   }
    //   next()
    // },

    handleConfirm() {
      this.setFocusIndex(0)
      this.$emit('sku-select', {
        sku: { ...this.form },
        ifAccumulate: this.ifAccumulate,
      })
      this.clear()
    },

    handleClose() {
      this.ifScanGun = false
      this.clear()
    },

    onSuggestionsDialogOpen() {
      // 中心模式：主搜索框 widget onScan 与弹窗 dialog onScan 双登记，显式卸掉 widget 侧避免竞态
      if (this.useScanCenter) {
        this.handOffScanner()
      }
    },

    onSuggestionsDialogClose(isSelected) {
      if (this.useScanCenter && !this.pauseScanner) {
        this.handOnScanner()
      }
      if (!isSelected) {
        this.setFocusIndex(0)
      }
    },

    setFocusIndex(index = 0) {
      if (index < 0 || index > this.inputComponents.length) return
      this.inputComponents[index]?.focus()
      this.inputComponents[index]?.select()
    },

    clear() {
      this.form.skuName = null
      this.form.skuCode = null
      this.$refs.mgAutocomplete.closeClear()
    },
    handleSearchMore() {
      this.$emit('search-more')
    },
    addQty() {
      let qty = this.form[this.defaultQty]
      if (qty === '') qty = 0
      if (this.negative && qty == -1) {
        this.changeQty(qty + 2)
        return
      }
      this.changeQty(qty + 1)
    },
    minusQty() {
      let qty = this.form[this.defaultQty]
      if (qty === '') qty = 1
      if (this.negative && qty == 1) {
        this.changeQty(qty - 2)
        return
      }
      if (qty === 1) return
      this.changeQty(qty - 1)
    },
    changeQty(qty) {
      if (this.ifDefaultQtyField) {
        if (qty === '') qty = 1
        if (qty === '-') qty = -1
        this.form[this.defaultQty] = qty
      }
    },
    handleQtyInput(value) {
      // 首位不能输入0
      if (this.form[this.defaultQty] == '' && value == 0) {
        this.form[this.defaultQty] = ''
        return
      }

      // 仅支持录入正数
      if (!this.negative) {
        if (!new RegExp(`^\\d*$`).test(value)) {
          this.form[this.defaultQty] = value.match(/^\d*/)[0]
        }
        return
      }

      // 同时支持录入正数和负数
      if (!new RegExp(`^-?\\d*$`).test(value)) {
        this.form[this.defaultQty] = value.match(/^-?\d*/)[0]
      }
    },
    blurSearchInput() {
      try {
        const comp = this.$refs.mgAutocomplete?.$refs?.input
        if (comp?.blur) comp.blur()
        if (typeof comp?.getInput === 'function') comp.getInput()?.blur()
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * 快捷键中心扫码回调（useScanCenter=true）
     */
    handleScanInput(code, ifScanGun) {
      if (this.pauseScanner) return
      this.ifScanGun = ifScanGun
      if (!ifScanGun) return

      this.setFocusIndex(0)
      this.disableIMEForScanning()

      if (code.toLowerCase().includes('process')) {
        this.$message.warning('输入法与扫码枪不兼容, 建议使用搜狗输入法。')
      }

      this.$refs?.mgAutocomplete?.handleKeyEnter({
        preventDefault: () => {},
        target: { value: code },
        ifScanGun,
      })

      this.form.skuName = code
    },
    handOffScanner() {
      if (this.useScanCenter) {
        this.$shortcuts?.setOnScan?.(this._shortcutScopeId, null)
        return
      }
      try {
        this.JSScanner.off()
        this.JSScanner = null
      } catch (e) {
        console.log('TIPS:关闭扫码枪监听失败1', e)
      }
    },
    //手动开启监听
    handOnScanner() {
      if (this.useScanCenter) {
        this.$shortcuts?.setOnScan?.(this._shortcutScopeId, this.handleScanInput)
        return
      }
      if (!this.JSScanner) {
        this.JSScanner = new JSScanner()
      }
      try {
        this.JSScanner.off()
      } catch (e) {
        console.log('TIPS:关闭扫码枪监听失败2', e)
      }

      this.JSScanner.on((code, ifScanGun) => {
        if (this.pauseScanner) return
        this.ifScanGun = ifScanGun
        if (ifScanGun) {
          this.setFocusIndex(0)
          this.disableIMEForScanning()
          this.$refs?.mgAutocomplete?.handleKeyEnter({
            preventDefault: () => {},
            target: { value: code },
            ifScanGun,
          })

          this.form.skuName = code
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep(.el-input__suffix) {
  color: $mg--color-gray;
  line-height: 40px;
}

.search-button {
  display: flex;
  align-items: center;

  ::v-deep(.iconfont) {
    font-size: 18px;
  }
}

.popover-arrow {
  cursor: pointer;
  transform: rotate(-90deg);
  color: #3a73ff;
  font-size: 14px;
  font-weight: 600 !important;
  display: block !important;
}
</style>
